<div class="grading mt-5">
  <div class="row mx-n2">
    <div class="px-2" [ngClass]="gradePV > 0 ? 'col-lg-6' : 'col-12'">
      <div class="grading__box mb-4">
        <div class="grading__header">
          <h2 class="fs fs__md-high mr-2">CV</h2>
          <button class="btn btn__utils" tooltip="Calculated Value">
            <ion-icon name="information-circle-outline" class="color-yellow ion-lg untouchable">
            </ion-icon>
          </button>
        </div>
        <canvas id="gauge" class="img-fluid"></canvas>
        <div class="grading__footer">
          <h4 class="grading__grade mr-2">
            {{ gradeCV > gradeCV ? '5.0' : (gradeCV | number : '0.1-2') }}
          </h4>
          <p class="grading__title">
            <ng-container *ngIf="gradeCV >= 5">
              ({{ 'grading.excellent' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 4.5 && gradeCV !== 5">
              ({{ 'grading.good' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 4 && gradeCV <= 4.5">
              ({{ 'grading.v_fair' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 3.5 && gradeCV <= 3.999">
              ({{ 'grading.fair' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 3 && gradeCV <= 3.5">
              ({{ 'grading.average' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 2.5 && gradeCV <= 2.999">
              ({{ 'grading.below_average' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 2 && gradeCV <= 2.4">
              ({{ 'grading.poor' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 1.5 && gradeCV <= 1.999">
              ({{ 'grading.v_poor' | translate }})
            </ng-container>
            <ng-container *ngIf="gradeCV >= 1 && gradeCV <= 1.5">
              ({{ 'grading.junk' | translate }})
            </ng-container>
          </p>
        </div>
      </div>
    </div>

    <div class="col-lg-6 px-2" *ngIf="gradePV > 0">
      <div class="grading__box">
        <div class="grading__header">
          <h2 class="fs fs__md-high mr-2">PV</h2>
          <button class="btn btn__utils" tooltip="Perceived Value">
            <ion-icon name="information-circle-outline" class="color-yellow ion-lg untouchable">
            </ion-icon>
          </button>
        </div>
        <canvas id="gauge2" class="img-fluid"></canvas>
        <div class="grading__footer">
          <h4 class="grading__grade mr-2">
            {{ gradePV > gradePV ? '5.0' : (gradePV | number : '0.1-2') }}
          </h4>
          <p class="grading__title">
            <ng-container *ngIf="gradePV >= 5">
              ({{ 'grading.excellent' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 4.5 && gradePV !== 5">
              ({{ 'grading.good' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 4 && gradePV <= 4.5">
              ({{ 'grading.v_fair' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 3.5 && gradePV <= 3.999">
              ({{ 'grading.fair' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 3 && gradePV <= 3.5">
              ({{ 'grading.average' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 2.5 && gradePV <= 2.999">
              ({{ 'grading.below_average' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 2 && gradePV <= 2.4">
              ({{ 'grading.poor' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 1.5 && gradePV <= 1.999">
              ({{ 'grading.v_poor' | translate }})
            </ng-container>
            <ng-container *ngIf="gradePV >= 1 && gradePV <= 1.5">
              ({{ 'grading.junk' | translate }})
            </ng-container>
          </p>

          <button class="btn btn__action reason ml-auto" [popover]="reason" placement="bottom">
            <ion-icon name="help-circle-outline" class="ion-lg untouchable"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #reason>
  <div class="table-responsive">
    <table class="table grading grading__table">
      <thead>
        <tr>
          <th>Factors</th>
          <th>Condition</th>
          <th>Values</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let factor of endCorrectionFactors">
          <td class="text-capitalize">{{ factor.factor }}</td>

          <td *ngIf="factor.selectedCondition.length">
            <ol class="m-0 pl-3">
              <li *ngFor="let condition of factor.selectedCondition">
                <ng-container *ngIf="lang === 'en'">{{
                  condition['parts_condition_name']
                }}</ng-container>
                <ng-container *ngIf="lang === 'ar'">{{
                  condition['parts_condition_name_arabic']
                }}</ng-container>
              </li>
            </ol>
          </td>
          <td *ngIf="!factor.selectedCondition.length">N/A</td>

          <td>{{ factor.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
